import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getPaginated(params) {
        return axios.get(`${API_URL}/promotions`, {
            headers: authHeader(),
            params,
        });
    },
    getById(id) {
        return axios.get(`${API_URL}/promotions/${id}`, { headers: authHeader() });
    },
    searchProducts(params) {
        return axios.get(`${API_URL}/promotions/products`, {
            headers: authHeader(),
            params,
        });
    },
    createData(data) {
        return axios.post(`${API_URL}/promotions`, data, { headers: authHeader() });
    },
    updateData(id, data) {
        return axios.put(`${API_URL}/promotions/${id}`, data, { headers: authHeader() });
    },
    deleteData(id) {
        return axios.delete(`${API_URL}/promotions/${id}`, { headers: authHeader() });
    },
};
